import React, { useContext, useState, useEffect } from 'react';
import { GMCContext } from '../../GMCContext';
import Header from "../Common/Header";
import Sidebar from "../Common/Sidebar";
import Footer from "../Common/Footer";
import axios from "axios";
import Swal from "sweetalert2";
import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_SOCKET_URL, {
    transports: ["websocket", "polling"],
});

socket.on("connect", () => {
    console.log("🔥 Structure Socket connected:", socket.id);
});


export default function UserStructure() {
    const { togel, setTogel, toastError, isSidebarEnabled, setIsSidebarEnabled, formatDateTime, setToken } = useContext(GMCContext);
    const statedata = JSON.parse(localStorage.getItem('mark#0143'))
    const [txUserId, setTxUserId] = useState("");
    const [balance, setBalance] = useState(0);
    const [actionLoading, setActionLoading] = useState(false);
    const [authNumber, setAuthNumber] = useState("");
    const [Tbalance, setTBalance] = useState(0);
    const [loadingBalance, setLoadingBalance] = useState(false);
    const [actionType, setActionType] = useState("structure");

    const [structureType, setStructureType] = useState(0); // depth | direct
    const [userCount, setUserCount] = useState("");
    const [isUserFound, setIsUserFound] = useState(false);
    const [error, setError] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [msg, setMsg] = useState("");
    const [showMsg, setShowMsg] = useState(false);
    const [isVerified, setIsVerified] = useState(false);

    // 🔥 Progress Tracking States
    const [progress, setProgress] = useState({ total: 0, completed: 0, status: "idle" });
    const [jobId, setJobId] = useState(null);
    const [showBlocker, setShowBlocker] = useState(false);
    const [blockerStatus, setBlockerStatus] = useState("loading"); // loading | success | error

    const insertCode = async () => {
        try {
            const response = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "verify",
                submethod: "insert",
                key: process.env.REACT_APP_KEY,
                authNumber: authNumber,
                username: statedata?.username,
                _id: statedata?.id,
            });

            const { resCode, error, token } = response.data;

            if (resCode === 200) {
                if (token) {
                    setMsg("Verified Successfully");
                    setShowMsg(true);
                    localStorage.setItem("mark#321", token);
                    localStorage.setItem("mark#0143", JSON.stringify({ username: statedata?.username, id: statedata?.id }));
                    if (setToken) setToken(token);
                    setIsVerified(true);
                    setAuthNumber("");
                } else {
                    setErrorMessage("Unable To Generate Token.");
                    setError(true);
                }
            } else {
                setErrorMessage(error || "Verification Failed. Please Try Again.");
                setError(true);
            }
        } catch (err) {
            console.error("Error Inserting Data:", err);
            setErrorMessage("Network Error. Please Try Again Later.");
            setError(true);
        }
    };

    const fetchBalance = async () => {
        if (!txUserId) {
            Swal.fire("Error", "Enter User ID", "error");
            return;
        }

        try {
            setLoadingBalance(true);
            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "user",
                submethod: "profile",
                key: process.env.REACT_APP_KEY,
                username: txUserId,
            });

            if (res.data?.resCode === 200) {
                setIsUserFound(true);
            } else {
                Swal.fire("Error", res.data?.error || res.data?.message || "User not found", "error");
                setIsUserFound(false);
            }
        } catch {
            Swal.fire("Error", "Server error", "error");
        } finally {
            setLoadingBalance(false);
        }
    };

    useEffect(() => {
        if (!txUserId || txUserId.trim() === "") {
            setIsUserFound(false);
        }
    }, [txUserId]);

    useEffect(() => {
        socket.on("structure-progress", (data) => {
            console.log("STRUCTURE PROGRESS:", data);
            
            const match = jobId && data.jobId && data.jobId.toLowerCase() === jobId.toLowerCase();

            if (!jobId || match) {
                setProgress(prev => ({ ...prev, ...data }));
                
                if (data.status === "processing") {
                    setShowBlocker(true);
                    setBlockerStatus("loading");
                }
                if (data.status === "done") {
                    // We don't hide blocker yet, let the axios response handle final data
                }
                if (data.status === "error") {
                    setBlockerStatus("error");
                }
            }
        });

        return () => socket.off("structure-progress");
    }, [jobId]);

    const handleStructureSubmit = async () => {
        if (!txUserId || !structureType || !userCount) {
            Swal.fire("Error", "Please fill all fields", "error");
            return;
        }

        if (Number(userCount) > 10) {
            Swal.fire("Warning", "Maximum 10 users can be created at once", "warning");
            return;
        }

        if (Number(userCount) <= 0) {
            Swal.fire("Error", "User count must be at least 1", "error");
            return;
        }

        try {
            setActionLoading(true);
            setJobId(txUserId);
            setShowBlocker(true);
            setBlockerStatus("loading");

            const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
                method: "admin",
                submethod: "structure",
                ROOT: txUserId,
                type: structureType,
                chainLength: userCount,
                key: process.env.REACT_APP_KEY,
            });
            console.log('res.data?.resCode', res);

            if (res.data?.resCode === 200) {
                const chainUsers = res.data?.data?.chainUsers || [];
                let htmlContent = "";

                if (chainUsers.length > 0) {
                    htmlContent = `
                        <div class="generated-users-list" style="margin-top: 20px; text-align: left;">
                            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                                <p style="font-weight: 700; color: #1e293b; margin: 0; font-size: 14px; display: flex; align-items: center; gap: 8px;">
                                    <i class="ri-user-follow-line" style="color: #405189;"></i> Generated Usernames
                                </p>
                                ${chainUsers.length > 1 ? `
                                    <button id="copy-all-btn" style="background: transparent; color: #405189; border: 1px solid #405189; padding: 4px 10px; border-radius: 8px; cursor: pointer; font-size: 11px; font-weight: 700; display: flex; align-items: center; gap: 4px;">
                                        <i class="ri-copy-line"></i> Copy All
                                    </button>
                                ` : ''}
                            </div>
                            <div style="max-height: 250px; overflow-y: auto; padding-right: 5px;">
                                ${chainUsers.map(user => `
                                    <div style="display: flex; justify-content: space-between; align-items: center; background: #f8fafc; padding: 12px 16px; border-radius: 14px; margin-bottom: 8px; border: 1px dashed #cbd5e1;">
                                        <span style="font-family: 'JetBrains Mono', monospace; font-weight: 700; color: #405189; font-size: 15px;">${user}</span>
                                      
                                    </div>
                                `).join('')}
                            </div>
                        </div>
                    `;
                }

                Swal.fire({
                    title: "Structure Created!",
                    html: `
                        <div style="color: #64748b; font-size: 15px; margin-bottom: 5px;">${res.data.msg || "User structure has been successfully established."}</div>
                        ${htmlContent}
                    `,
                    icon: "success",
                    confirmButtonText: "Ok",
                    confirmButtonColor: "#405189",
                    didOpen: () => {
                        // Individual copy buttons
                        // const copyBtns = document.querySelectorAll('.copy-btn-swal');
                        // copyBtns.forEach(btn => {
                        //     btn.addEventListener('click', async () => {
                        //         const user = btn.getAttribute('data-user');
                        //         try {
                        //             await navigator.clipboard.writeText(user);
                        //             const icon = btn.querySelector('i');
                        //             icon.className = 'ri-check-line';
                        //             btn.style.background = '#10b981';
                        //             setTimeout(() => {
                        //                 icon.className = 'ri-file-copy-line';
                        //                 btn.style.background = '#405189';
                        //             }, 2000);
                        //         } catch (err) {
                        //             console.error('Failed to copy: ', err);
                        //         }
                        //     });
                        // });

                        // Copy all button
                        const copyAllBtn = document.getElementById('copy-all-btn');
                        if (copyAllBtn) {
                            copyAllBtn.addEventListener('click', async () => {
                                try {
                                    await navigator.clipboard.writeText(chainUsers.join(', '));
                                    const originalHtml = copyAllBtn.innerHTML;
                                    copyAllBtn.innerHTML = '<i class="ri-check-line"></i> Copied All';
                                    copyAllBtn.style.color = '#10b981';
                                    copyAllBtn.style.borderColor = '#10b981';
                                    setTimeout(() => {
                                        copyAllBtn.innerHTML = originalHtml;
                                        copyAllBtn.style.color = '#405189';
                                        copyAllBtn.style.borderColor = '#405189';
                                    }, 2000);
                                } catch (err) {
                                    console.error('Failed to copy all: ', err);
                                }
                            });
                        }
                    }
                });

                setStructureType("");
                setUserCount("");
                setIsUserFound(false);
                setTxUserId("");
                setBlockerStatus("success");
            } else {
                setBlockerStatus("error");
                Swal.fire("Error", res.data?.error || "Failed to create structure", "error");
            }
        } catch (error) {
            Swal.fire("Error", "Server error", "error");
        } finally {
            setActionLoading(false);
        }
    };


    return (
        <>
            <Header />
            <Sidebar />

            {showBlocker && (
                <div className="global-operation-blocker">
                    <div className="blocker-content">
                        {blockerStatus === "loading" ? (
                            <>
                                <div className="spinning-ring"></div>
                                <i className="ri-error-warning-line forbidden-icon"></i>
                                <p className="fw-bold">
                                    {progress.status === "processing"
                                        ? `Creating Structure ${progress.completed} / ${progress.total}`
                                        : "Initializing Creation..."}
                                </p>
                                {progress.status === "processing" && (
                                    <div className="w-100 mt-3" style={{ minWidth: '300px' }}>
                                        <div className="d-flex justify-content-between mb-1">
                                            <small className="text-muted">Generation Progress</small>
                                            <small className="fw-bold">{progress.completed} / {progress.total}</small>
                                        </div>
                                        <div className="progress" style={{ height: "10px", borderRadius: '10px' }}>
                                            <div
                                                className="progress-bar progress-bar-striped progress-bar-animated bg-primary"
                                                role="progressbar"
                                                style={{ width: `${progress.total ? (progress.completed / progress.total) * 100 : 0}%` }}
                                            ></div>
                                        </div>
                                    </div>
                                )}
                                <small className="text-muted">Interacting with the sidebar is disabled during generation</small>
                            </>
                        ) : blockerStatus === "success" ? (
                            <>
                                <div className="success-icon-wrapper">
                                    <i className="ri-checkbox-circle-fill text-success" style={{ fontSize: '60px' }}></i>
                                </div>
                                <p className="text-success fw-bold fs-18">Structure Generated successfully!</p>
                                <button className="btn btn-success px-5 rounded-pill" onClick={() => {
                                    setShowBlocker(false);
                                    setBlockerStatus("loading");
                                    setProgress({ total: 0, completed: 0, status: "idle" });
                                }}>
                                    Continue
                                </button>
                            </>
                        ) : (
                            <>
                                <div className="error-icon-wrapper">
                                    <i className="ri-close-circle-fill text-danger" style={{ fontSize: '60px' }}></i>
                                </div>
                                <p className="text-danger fw-bold fs-18">Generation Failed</p>
                                <button className="btn btn-danger px-5 rounded-pill" onClick={() => {
                                    setShowBlocker(false);
                                    setBlockerStatus("loading");
                                }}>
                                    Try Again
                                </button>
                            </>
                        )}
                    </div>
                </div>
            )}

            <div className="buy-package-container">
                <h2 className="buy-title">User Structure</h2>

                <div className="structure-content">
                    {!isVerified ? (
                        <div className="glass-card auth-card">
                            <div className="form-icon">
                                <i className="ri-shield-keyhole-line"></i>
                            </div>
                            <h3>Verification Required</h3>
                            <p>Please enter your authentication key to access user structure operations.</p>
                            <div className="input-field-wrapper">
                                <input
                                    type="number"
                                    placeholder="Enter Auth Key"
                                    value={authNumber}
                                    onChange={(e) => setAuthNumber(e.target.value)}
                                />
                            </div>
                            {errorMessage && <div className="error-alert">{errorMessage}</div>}
                            <button className="primary-btn full" onClick={insertCode}>
                                {actionLoading ? <span className="loader"></span> : "Verify Access"}
                            </button>
                        </div>
                    ) : (
                        <div className="main-structure-flow">
                            <div className="glass-card search-card">
                                <div className="input-field-wrapper">
                                    <i className="ri-user-search-line prefix-icon"></i>
                                    <input
                                        type="text"
                                        placeholder="Enter Referral Username"
                                        value={txUserId}
                                        onChange={(e) => setTxUserId(e.target.value)}
                                    />
                                    <button className="search-btn" onClick={fetchBalance} disabled={loadingBalance}>
                                        {loadingBalance ? <i className="ri-loader-4-line spin"></i> : "Find User"}
                                    </button>
                                </div>
                            </div>

                            {actionType === "structure" && isUserFound && (
                                <div className="glass-card form-card animate-slide-up">
                                    <div className="form-header">
                                        <h4>Creation Parameters</h4>
                                        <span className="badge">Verified: {txUserId}</span>
                                    </div>

                                    <div className="type-selection-grid">
                                        <label className={`selectable-card ${structureType === 0 ? "active" : ""}`}>
                                            <input
                                                type="radio"
                                                name="structureType"
                                                value={0}
                                                checked={structureType === 0}
                                                onChange={(e) => setStructureType(e.target.value)}
                                            />
                                            <div className="card-content">
                                                <i className="ri-node-tree"></i>
                                                <span>Depth</span>
                                                <small>Hierarchical Chain</small>
                                            </div>
                                        </label>
                                        <label className={`selectable-card ${structureType === 1 ? "active" : ""}`}>
                                            <input
                                                type="radio"
                                                name="structureType"
                                                value={1}
                                                checked={structureType === 1}
                                                onChange={(e) => setStructureType(e.target.value)}
                                            />
                                            <div className="card-content">
                                                <i className="ri-links-line"></i>
                                                <span>Direct</span>
                                                <small>Horizontal Frontline</small>
                                            </div>
                                        </label>
                                    </div>

                                    {structureType && (
                                        <div className="parameters-body animate-fade-in">
                                            <div className="input-group-field">
                                                <label>Member Quantity <span className="limit-hint">(Max 10)</span></label>
                                                <div className="number-input-wrapper">
                                                    <input
                                                        type="number"
                                                        max="10"
                                                        placeholder="0"
                                                        value={userCount}
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (Number(val) <= 10) setUserCount(val);
                                                        }}
                                                    />
                                                    <div className="limit-track" style={{ width: `${(Number(userCount) / 10) * 100}%` }}></div>
                                                </div>
                                            </div>

                                            {/* {actionLoading && (
                                                <div className="processing-indicator animate-fade-in">
                                                    <div className="progress-track">
                                                        <div className="progress-fill indeterminate"></div>
                                                    </div>
                                                    <p className="loading-status">Building Structure...</p>
                                                </div>
                                            )} */}

                                            <div className="action-footer">
                                                <button
                                                    className="primary-btn"
                                                    onClick={handleStructureSubmit}
                                                    disabled={actionLoading}
                                                >
                                                    {actionLoading ? "Processing..." : "Create Structure"}
                                                </button>
                                                <button
                                                    className="secondary-btn"
                                                    onClick={() => {
                                                        setStructureType("");
                                                        setUserCount("");
                                                        setIsUserFound(false);
                                                    }}
                                                >
                                                    Reset
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>

            <style>
                {`
                .buy-package-container {
                    max-width: 800px;
                    margin: 80px auto 40px;
                    padding: 20px;
                    font-family: 'Inter', system-ui, -apple-system, sans-serif;
                }

                .buy-title {
                    font-size: clamp(24px, 5vw, 32px);
                    font-weight: 800;
                    background: linear-gradient(135deg, #405189, #1a2a6c);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    margin-bottom: 40px;
                    text-align: center;
                    letter-spacing: -1px;
                }

                .glass-card {
                    background: rgba(255, 255, 255, 0.98);
                    backdrop-filter: blur(12px);
                    border: 1px solid rgba(226, 232, 240, 0.8);
                    border-radius: 28px;
                    padding: clamp(20px, 4vw, 40px);
                    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.03), 0 5px 15px rgba(64, 81, 137, 0.05);
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .auth-card {
                    text-align: center;
                    max-width: 480px;
                    margin: 0 auto;
                }

                .form-icon {
                    font-size: 56px;
                    background: linear-gradient(135deg, #405189, #2b3a67);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    margin-bottom: 24px;
                }

                .auth-card h3 {
                    font-size: 24px;
                    font-weight: 800;
                    color: #1e293b;
                    margin-bottom: 12px;
                }

                .auth-card p {
                    color: #64748b;
                    font-size: 15px;
                    line-height: 1.7;
                    margin-bottom: 30px;
                }

                .input-field-wrapper {
                    position: relative;
                    margin-bottom: 20px;
                    display: flex;
                    align-items: center;
                    background: #f8fafc;
                    border: 2px solid #f1f5f9;
                    border-radius: 18px;
                    padding: 6px 6px 6px 20px;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .input-field-wrapper:focus-within {
                    border-color: #405189;
                    background: #fff;
                    box-shadow: 0 10px 25px rgba(64, 81, 137, 0.08);
                    transform: translateY(-2px);
                }

                .input-field-wrapper input {
                    border: none;
                    background: transparent;
                    padding: 14px 12px;
                    width: 100%;
                    font-size: 16px;
                    color: #1e293b;
                    font-weight: 500;
                    outline: none;
                }

                .prefix-icon {
                    font-size: 20px;
                    color: #94a3b8;
                }

                .primary-btn {
                    background: linear-gradient(135deg, #405189, #2b3a67);
                    color: white;
                    border: none;
                    padding: 16px 32px;
                    border-radius: 18px;
                    font-weight: 700;
                    font-size: 16px;
                    cursor: pointer;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 10px;
                }

                .primary-btn.full { width: 100%; }

                .primary-btn:hover:not(:disabled) {
                    transform: translateY(-3px);
                    box-shadow: 0 12px 24px rgba(64, 81, 137, 0.25);
                }

                .primary-btn:active {
                    transform: translateY(-1px);
                }

                .secondary-btn {
                    background: #f1f5f9;
                    color: #475569;
                    border: none;
                    padding: 16px 32px;
                    border-radius: 18px;
                    font-weight: 700;
                    cursor: pointer;
                    transition: all 0.3s ease;
                }

                .secondary-btn:hover {
                    background: #e2e8f0;
                    color: #1e293b;
                }

                .search-btn {
                    background: #405189;
                    color: white;
                    border: none;
                    padding: 12px 24px;
                    border-radius: 14px;
                    font-weight: 700;
                    font-size: 14px;
                    cursor: pointer;
                    white-space: nowrap;
                }

                .search-card { margin-bottom: 30px; }

                .form-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 30px;
                    padding-bottom: 15px;
                    border-bottom: 2px solid #f8fafc;
                }

                .form-header h4 {
                    margin: 0;
                    color: #1e293b;
                    font-size: 20px;
                    font-weight: 800;
                }

                .badge {
                    background: #f0f4ff;
                    color: #405189;
                    padding: 8px 16px;
                    border-radius: 24px;
                    font-size: 13px;
                    font-weight: 700;
                    border: 1px solid rgba(64, 81, 137, 0.1);
                }

                .type-selection-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
                    gap: 16px;
                    margin-bottom: 35px;
                }

                .selectable-card {
                    cursor: pointer;
                    position: relative;
                }

                .selectable-card input {
                    position: absolute;
                    opacity: 0;
                }

                .card-content {
                    background: #fff;
                    border: 2px solid #f1f5f9;
                    border-radius: 22px;
                    padding: 24px;
                    text-align: center;
                    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 10px;
                }

                .card-content i {
                    font-size: 32px;
                    color: #94a3b8;
                    transition: color 0.3s ease;
                }

                .card-content span {
                    font-weight: 800;
                    color: #334155;
                    font-size: 17px;
                }

                .card-content small {
                    font-size: 12px;
                    color: #64748b;
                    font-weight: 500;
                }

                .selectable-card:hover .card-content {
                    border-color: #e2e8f0;
                    transform: translateY(-4px);
                }

                .selectable-card.active .card-content {
                    border-color: #405189;
                    background: rgba(64, 81, 137, 0.03);
                    box-shadow: 0 10px 20px rgba(64, 81, 137, 0.06);
                }

                .selectable-card.active .card-content i {
                    color: #405189;
                    transform: scale(1.1);
                }

                .selectable-card.active .card-content span {
                    color: #405189;
                }

                .parameters-body { margin-top: 35px; }

                .input-group-field label {
                    display: block;
                    font-weight: 700;
                    color: #334155;
                    margin-bottom: 12px;
                    font-size: 15px;
                    padding-left: 4px;
                }

                .limit-hint {
                    color: #94a3b8;
                    font-weight: 500;
                    font-size: 13px;
                    margin-left: 6px;
                }

                .number-input-wrapper {
                    position: relative;
                    background: #f8fafc;
                    border-radius: 18px;
                    overflow: hidden;
                    border: 2px solid #f1f5f9;
                    transition: all 0.3s ease;
                }

                .number-input-wrapper:focus-within {
                    border-color: #405189;
                    background: #fff;
                }

                .number-input-wrapper input {
                    padding: 16px 20px;
                    width: 100%;
                    border: none;
                    background: transparent;
                    font-weight: 800;
                    font-size: 22px;
                    color: #1e293b;
                    outline: none;
                }

                .limit-track {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    height: 4px;
                    background: linear-gradient(to right, #405189, #2b3a67);
                    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .action-footer {
                    display: flex;
                    gap: 15px;
                    margin-top: 40px;
                }

                @media (max-width: 640px) {
                    .buy-package-container {
                        margin-top: 60px;
                        padding: 15px;
                    }

                    .glass-card {
                        padding: 24px 20px;
                        border-radius: 22px;
                    }

                    .input-field-wrapper {
                        padding: 2px 2px 2px 14px;
                        border-radius: 14px;
                    }

                    .search-btn {
                        padding: 10px 16px;
                        font-size: 13px;
                    }

                    .type-selection-grid {
                        grid-template-columns: 1fr;
                        gap: 12px;
                    }

                    .card-content {
                        flex-direction: row;
                        padding: 16px;
                        gap: 16px;
                        text-align: left;
                    }

                    .card-content i { font-size: 24px; }

                    .action-footer {
                        flex-direction: column;
                    }

                    .primary-btn, .secondary-btn {
                        width: 100%;
                        font-size: 15px;
                    }

                    .form-header {
                        flex-direction: column;
                        align-items: flex-start;
                        gap: 12px;
                    }
                }

                .loader {
                    width: 20px;
                    height: 20px;
                    border: 3px solid rgba(255, 255, 255, 0.3);
                    border-radius: 50%;
                    border-top-color: #fff;
                    animation: spin 0.8s linear infinite;
                }

                .global-operation-blocker {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100vw;
                    height: 100vh;
                    background: rgba(255, 255, 255, 0.4);
                    backdrop-filter: blur(4px);
                    z-index: 99999;
                    cursor: not-allowed;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    pointer-events: all;
                }

                .blocker-content {
                    background: white;
                    padding: 40px;
                    border-radius: 30px;
                    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15);
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 15px;
                    border: 1px solid #f1f5f9;
                    max-width: 90%;
                }

                .forbidden-icon {
                    font-size: 40px;
                    color: #ef4444;
                    position: absolute;
                    margin-top: 10px;
                }

                .spinning-ring {
                    width: 80px;
                    height: 80px;
                    border: 4px solid #f1f5f9;
                    border-top: 4px solid #405189;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                }

                .blocker-content p {
                    font-weight: 800;
                    color: #1e293b;
                    margin: 0;
                    font-size: 18px;
                }

                .blocker-content small {
                    color: #64748b;
                    font-weight: 500;
                }

                .processing-indicator {
                    margin-top: 25px;
                    background: #f8fafc;
                    padding: 20px;
                    border-radius: 20px;
                    border: 1px solid #f1f5f9;
                }

                .progress-track {
                    height: 6px;
                    background: #e2e8f0;
                    border-radius: 10px;
                    overflow: hidden;
                    position: relative;
                }

                .progress-fill.indeterminate {
                    width: 40%;
                    height: 100%;
                    background: linear-gradient(90deg, #405189, #2b3a67);
                    position: absolute;
                    left: -40%;
                    animation: indeterminateProgress 1.5s infinite ease-in-out;
                    border-radius: 10px;
                }

                @keyframes indeterminateProgress {
                    0% { left: -40%; }
                    100% { left: 140%; }
                }

                .loading-status {
                    margin-top: 12px;
                    font-size: 13px;
                    font-weight: 700;
                    color: #405189;
                    text-align: center;
                    letter-spacing: 0.5px;
                    text-transform: uppercase;
                }

                .error-alert {
                    color: #dc2626;
                    background: #fef2f2;
                    padding: 14px;
                    border-radius: 14px;
                    margin-bottom: 20px;
                    font-size: 14px;
                    font-weight: 600;
                    border: 1px solid rgba(220, 38, 38, 0.1);
                    text-align: center;
                    animation: shake 0.4s cubic-bezier(.36,.07,.19,.97) both;
                }

                @keyframes shake {
                    10%, 90% { transform: translate3d(-1px, 0, 0); }
                    20%, 80% { transform: translate3d(2px, 0, 0); }
                    30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
                    40%, 60% { transform: translate3d(4px, 0, 0); }
                }

                .animate-slide-up { animation: slideUp 0.6s cubic-bezier(0.23, 1, 0.32, 1) forwards; }
                .animate-fade-in { animation: fadeIn 0.5s ease forwards; }

                @keyframes slideUp {
                    from { transform: translateY(30px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                .spin { animation: spin 1s linear infinite; }
                @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
                `}
            </style>
            <Footer />
        </>
    );
}
